import React, { useState } from "react"
import  "../AnbarGardaniStyle.css";

const LastLogModal=(props)=>{
    
    return(
        <React.Fragment>
          
<div className="location_modal text-right">
<div className="location_modal_box">
    <div className="location_modal_header bg-dark p-2">
<span className=" w-100 text-right text-white">اخطار</span>
    </div>
    <div className="p-4 text-center">
<p>
     {props.text}
</p>
<p>
</p>
<hr />
<div className="row text-right my-3 " style={{direction:"rtl"}}>
    <div className="col-6 text-left">
    <button className="btn btn-success w-50" onClick={props.apply}>افزودن</button>
    </div>
    <div className="col-6  text-right">

    <button className="btn btn-danger w-50" onClick={props.close}>انصراف</button>
    </div>
    </div>
    </div>
   

</div> 
</div> 
            </React.Fragment>
        )
}
export default LastLogModal;